<template>

    <v-modal
        :open="open"
        class="c-new_issue_modal">
        <h2 class="c-new_issue_modal__title">Dodawanie nowego problemu</h2>
        <form @submit.prevent="save" data-vv-scope="new_issue-form">
            <form-input
                v-model="newIssue"
                label="Nowy problem"
                v-validate="'required'"
                data-vv-as="problem"
                speech-to-text
                :list-options="defaultIssueNames">
            </form-input>
            <form-row align="between">
                <v-btn
                    type="green"
                    role="submit"
                    has-loader
                    :loading="isLoading">
                    Dodaj
                </v-btn>
                <v-btn
                    type="white"
                    @click="cancel">
                    Anuluj
                </v-btn>
            </form-row>
        </form>
    </v-modal>

</template>


<script>

import VModal from 'Components/VModal'
import {FormRow, FormInput} from 'Components/Form'
import VBtn from 'Components/VBtn'
import {mapGetters} from "vuex";

export default {

    name: 'IssueAddModal',

    data() {
        return {
            newIssue: '',
            open: false,
            isLoading: false
        }
    },

    computed: {
        ...mapGetters(['visitDefaultIssues', 'visitIssues', 'errors']),

        defaultIssueNames() {
            const visitIssueNames = this.visitIssues.map(visitIssue => visitIssue.name);
            return this.visitDefaultIssues.map(visitDefaultIssue => {
                if (!visitIssueNames.includes(visitDefaultIssue.name)) {
                    return visitDefaultIssue.name;
                }
            });
        }
    },

    methods: {
        cancel() {
            this.open = false
        },

        save() {
            this.$validator.validateAll('new_issue-form').then((isValid) => {
                if (isValid) {
                    this.isLoading = true
                    this.$store.dispatch('VISIT_ISSUE_STORE', {
                        patient_id: this.$route.params.id,
                        name: this.newIssue
                    }).then(({data}) => {
                        this.isLoading = false
                        this.$alert.success('Dodawanie problemu', data.message)
                        this.open = false
                        this.newIssue = ''
                        this.$store.dispatch('VISIT_ISSUES_FETCH', this.$route.params.id).then(() => {
                            this.$emit('success', data.data)
                        })

                    }).catch((error) => {
                        this.isLoading = false
                        this.$alert.error('Dodawanie problemu', error.response.data.message)
                        this.open = false
                        this.$emit('failure')
                    })
                } else {
                    this.$alert.error('Dodawanie problemu', 'Musisz podać nazwę problemu')
                }
            })
        },
    },

    mounted() {
        this.$on('open', () => {
            this.open = true
            this.isFetching = true

            this.$store.dispatch('VISIT_DEFAULT_ISSUES_FETCH').then(() => {
                this.isFetching = false;
            }).catch((error) => {
                this.$alert.error('Nie można dodać wizyty.', error.response.data.message)
                this.open = false
            })
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        FormRow,
        FormInput,
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-new_issue_modal {
    &__title {
        margin-bottom: 2rem;
    }
}

</style>
